import React from "react";
import { Link } from 'react-router-dom'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
// import image1 from "assets/img/24092018.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                <CardBody>
                  {/* <center>
                    <img src={image1} alt="Career" style={{ width: 500, height: 250, marginRight: 25 }} />
                  </center> <br /> */}
                  <span style={{ marginBottom: 0 }}><b>December 17, 2018</b></span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>ISO 27001 CONSULTANT</b></h2>
                  <p>
                    We are a growing dynamic consulting firm based in Jakarta that expanding new business lines and territories, looking for exceptional talents with the following traits:
                  </p>
                  <ul>
                    <li>A passionate IT practitioner with a number of notable projects</li>
                    <li>Familiar with information security management system (ISMS) development, audit and maintenance</li>
                    <li>Having hands-on experience in information security, cyber security, IT auditing, penetration testing, and digital forensics</li>
                    <li>Having experience in conducting IT technical training for both entry level user and advanced IT professionals</li>
                    <li>Be able to develop comprehensive course materials</li>
                  </ul>
                  <p>
                    If you are,
                  </p>
                  <ul>
                    <li>Male/Female</li>
                    <li>Bachelor degree from reputable universities</li>
                    <li>Having more than 10 years of experience in information security management system</li>
                    <li>Familiar with ISO 27001 standard</li>
                    <li>Preferably having lead auditor certification by IRCA or equivalent institution</li>
                    <li>Preferably having one of the following certified ethical hacker (CEH), certified information security manager (CISM), certified secure software lifecycle professional (CSSLP), or certified information systems auditor (CISA)</li>
                    <li>Love to travel across Indonesia</li>
                  </ul>
                  <p>Please submit your CV / Resume to <Link to="#"><b> hrd@sandtonglobal.com </b> <span style={{ color: "black" }}> with subject: <b>“ISO 27001”.</b></span>  </Link></p>
                  <br />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/CareerPage/Sections/ProductSection.2.jsx